module.exports = fox._r("images/empty-icon-event.png", __webpack_public_path__ + "_/_/_/common/frame/images/empty-icon-event.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/empty-icon-event.png
// module id = 96
// module chunks = 2